import setCustomEventVersions from './setCustomEventVersions/index.js'

// Set source middlewares for Motos.net.
export default [setCustomEventVersions]
